global.utilities = {
	sortObjectByKeys(obj) {
		const sortedArray = Object.keys(obj).sort((a, b) => {
			return a.localeCompare(b)
		})

		const sortedObject = sortedArray.reduce((prev, curr, i) => {
			prev[curr] = obj[curr]
			return prev
		}, {})

		return sortedObject
	},

	getKeyByValue(object, value) {
		return Object.keys(object).find(key => object[key] === value)
	},
	
	// Generic helper function that can be used for the three operations:        
	operation(list1, list2, isUnion = false) {
		return list1.filter(
			(set => a => isUnion === set.has(a.id))(new Set(list2.map(b => b.id)))
		)
	},

	intersection(list1, list2, allowEmpty = false) {
		return this.operation(list1, list2, true)
	},

	intersectEmpty(list1, list2) {
		if (list1.length === 0) return list2

		return this.intersection(list1, list2)
	},

	leftJoin(list1, list2) {
		return this.operation(list1, list2)
	},
	
	rightJoin(list1, list2) {
		return this.leftJoin(list2, list1)
	},

	//logger: require('./logger')
}


// WEBPACK FOOTER //
// ./src/utilities/index.js